// extracted by mini-css-extract-plugin
export default {"message":"MessageBox_message__CGXDS"};